
// axios
import axios from "axios";
// option
import { ClientOption } from "../../../config/clientOption";

export const showProduct = async (queryKey: any) => {
    const { data: response } = await axios.get(`${process.env.REACT_APP_API_URL}products/${queryKey.queryKey[1]}`, ClientOption);
    return response.data;
}